// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Oekh","content":"styles_content__2mSf4","checkbox":"styles_checkbox__1p65K","checkboxLabel":"styles_checkboxLabel__2fYHg"};